import type {VersionInfo} from './app/utils.class';

export const compiledVersion: VersionInfo = {"buildNumber":"D. van der Steen B.V_acceptance_2026-11-05_11-0-11","buildId":"24926","environment":"trackline-acceptance","datetime":"2026-11-05T10:01:36.828Z","checkForUpdates":true}